export default __webpack_public_path__ + "static/media/app_demo_img.7ea4bae2.png";